// extracted by mini-css-extract-plugin
export default {"colorBannerText":"#1a1a1a","content_layout":"Payment_content_layout__-RNtB","error_container":"Payment_error_container__tGkPz"};